import { MLBuilder } from 'vue-multilanguage'

export default {
  1: new MLBuilder('COM_MSG014'),
  2: new MLBuilder('COM_MSG015'),
  3: new MLBuilder('COM_MSG016')
}